export default __webpack_public_path__ + "static/Release_Form-278a01b3aca636ce9a683afd7beec3ad.pdf";